import './Mission.css';
import toast from '../assets/cutouts/toast.png';
import hand from '../assets/cutouts/hand1.png';
import hand2 from '../assets/cutouts/hand2.png';
import spread from '../assets/cutouts/spread.png';
import knife from '../assets/cutouts/knife1.png';
import passionfruit from '../assets/cutouts/fruit-slice-passionfruit.png';
import blueberry from '../assets/cutouts/fruit-slice-blueberry.png';
import kiwi from '../assets/cutouts/fruit-slice-kiwi.png';
import strawberry from '../assets/cutouts/fruit-slice-strawberry.png';
//import linkedin from '../assets/icons/linkedin.png';

const FRUIT_ROW = [
  {img: passionfruit, alt: 'Passionfruit cross-section', className: 'is-passionfruit'},
  {img: blueberry, alt: 'Fruit cross-section', className: 'is-blueberry'},
  {img: kiwi, alt: 'Kiwi cross-section', className: 'is-kiwi'},
  {img: strawberry, alt: 'Strawberry cross-section', className: 'is-strawberry'},
];

function Mission() {
  return (
    <section className="Mission">
    {/*< h2 className="Mission-heading">Our Mission</h2>*/}

      <svg className="mission-title" height="1000" width="2000" xmlns="http://www.w3.org/2000/svg">
        <path id="lineAC" d="M 50 450 q 100 -250 530 -100" fill="none" />
        <text>
          <textPath href="#lineAC" startOffset="40" >Our Mission</textPath>
        </text>
      </svg>



      {/*
        hand.png is the pinch-grip hand/wrist; knife.png is gripped at the
        handle, blade angled up toward the toast. (A second, smaller copy
        of hand.png used to be layered on top here as a stand-in for
        fingertip detail, but its narrow crop box just forced object-fit:
        contain to shrink the whole hand image down small instead of
        cropping to the fingertips — it read as a stray duplicate hand, so
        it's gone.)
      */}
      <img className="Mission-hand" src={hand} alt="" />
      <img className="Mission-hand-2" src={hand2} alt="" />
      <img className="Mission-knife" src={knife} alt="" />
      <img className="Mission-spread" src={spread} alt="" />
      
      
      <img className="Mission-toast" src={toast} alt="Toast" />
      <p className="Mission-copy">
        We inspire to make plant-based living simple, enjoyable, and connected
        by a welcoming space where everyone can discover, share, and grow.
      </p>

      <div className="Mission-fruitRow">
        {FRUIT_ROW.map(({img, alt, className}) => (
          <div className={`Mission-fruit ${className}`}>
            <img className="Mission-fruitImg" src={img} alt={alt} />
          </div>
        ))}
      </div>


      {  
      /*<p className="Mission-linkedin">
        Find us on LinkedIn{' '}
        <a href="https://www.linkedin.com" target="_blank" rel="noreferrer">
          <img src={linkedin} alt="LinkedIn" />
        </a>
      </p>*/}
    </section>
  );
}

export default Mission;
